import { useLocation } from "react-router-dom"

export default function usePath(targetPath: Path) {
  const { pathname } = useLocation()

  return pathname.includes(targetPath)
}

type Path = "/vods" | "/chat-histories" | "/chat-mode" | "/streamer-chatting"
